import React, { Component } from "react";
import { Link } from "react-router-dom";

import SignHeader from "../component/SignHeader";
import Header from "../component/Header";

import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import NfcIcon from "@material-ui/icons/Nfc";

import "../scss/style.scss";
import "../scss/sign.scss";

import Dialog from "@material-ui/core/Dialog";
import Checkbox from '@material-ui/core/Checkbox';

import cookie from 'react-cookie';
//LSB
import queryString from 'query-string';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');

//var DEBUG11=true;
var DEBUG11=false;



function getOS() {
    var userAgent = window.navigator.userAgent,
            platform = window.navigator.platform,
            macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'],
            iphonePlatforms = ['iPhone','iPod'],
            ipadPlatforms = ['iPad'],
            os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
        if(userAgent.indexOf("iPad;")>-1) os = 'iPad';
    } else if (ipadPlatforms.indexOf(platform) !== -1) {
        os = 'iPad';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    }

    return os;
}

class TagComplaint extends Component {
	constructor(props) {
		super(props);

        //LSB
        const qvalue=queryString.parse(props.location.search);
        let from_url=qvalue.from_url;
        if(DEBUG11) console.log('from_url',from_url);

        if(from_url===undefined || from_url===null) {
           from_url="/";
        }

		this.state = {
			headerTitle: "더책",
            taginfo: '',
            sysinfo: '',
            agency: '',
            phone: '',
            bookinfo: '',
            message: '',
            privacy: false,
            open: false,
            self: this, 
            popup_message:''
		};

		let qs=cookie.load("initial_querystring");
		let params = queryString.parse(qs);
		this.state.sysinfo= "MODEL: "+params["device_model"] + "  OS: "+params["device_os"]+ "  APP: "+params["app_version"];

		this.doOpenAlert = this.doOpenAlert.bind(this);
		this.doCloseAlert = this.doCloseAlert.bind(this);
		this.doFocusTag = this.doFocusTag.bind(this);

		window.update_taginfo= this.update_taginfo_remote.bind(this);

	    if(getOS()=='iOS' || getOS()=='iPad')  {
	        setTimeout(()=>{window.webkit.messageHandlers.action.postMessage({'do':'read_nfc_tag','arg1':'report'});},3000);
	    }

	}

    update_taginfo_remote(itag) {
        document.getElementById('taginfo').value= itag;
        this.addClass( document.getElementById('taginfo'),'red_taginfo_bg');
        this.state.taginfo= itag;
        this.setState({taginfo: itag});
	}

	doFocusTag() {
	    if(getOS()=='iOS' || getOS()=='iPad')  {
	        window.webkit.messageHandlers.action.postMessage({'do':'read_nfc_tag','arg1':'report'});
	    }
	    console.log("dofocus tag");
	}

    addClass(element, className) { element.className += " " + className; };


	dopost() {

		var arg = {
		    taginfo: this.state.taginfo,
		    sysinfo: this.state.sysinfo,
		    agency: this.state.agency,
		    phone: this.state.phone,
		    bookinfo: this.state.bookinfo,
		    message: this.state.message,
		    privacy: this.state.privacy
		};
		console.log(JSON.stringify(arg));
		if(this.state.taginfo=="") {
		    this.addClass( document.getElementById('taginfo'),'red_input_placeholder');
		    document.getElementById('taginfo').focus();
		    return ;
		}
		if(this.state.agency=="") {
		    this.addClass( document.getElementById('agency'),'red_input_placeholder');
		    document.getElementById('agency').focus();
		    return ;
		}
		if(this.state.phone=="") {
		    this.addClass( document.getElementById('phone'),'red_input_placeholder');
		    document.getElementById('phone').focus();
		    return ;
		}
		if(this.state.bookinfo=="") {
		    this.addClass( document.getElementById('bookinfo'),'red_input_placeholder');
		    document.getElementById('bookinfo').focus();
		    return ;
		}
		if(this.state.message=="") {
		    this.addClass( document.getElementById('message'),'red_input_placeholder');
		    document.getElementById('message').focus();
		    return ;
		}
		if(this.state.privacy==false) {
		    this.addClass( document.getElementById('privacy_label'),'red_input_label_larger');
		    document.getElementById('privacy').focus();
		    return ;
		}
		
		var formBody = [];
		for (var property in arg) {
		    var encodedKey = encodeURIComponent(property);
		    var encodedValue = encodeURIComponent(arg[property]);
		    formBody.push(encodedKey + "=" + encodedValue);
		}
		formBody = formBody.join("&");

	    var old_headers= new Headers( {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
	    });
	    var old_formbody= JSON.stringify(arg);

	    var new_headers= new Headers( {
	        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
	    });
	    var new_formbody= formBody;

	    //console.log("new url "+new_formbody);
		//fetch("/api/AB/TagComplaint", { method: 'POST', headers: new_headers, body: new_formbody })
		fetch("/api/AB/TagComplaint?"+new_formbody)
			.then(response => response.json())
			.then(data => {
			    console.log(data);
                this.doOpenAlert('불편사항이 성공적으로 접수되었습니다');
			})
            .catch(ex => {
			    console.log(ex);
                this.doOpenAlert('불편사항이 접수되지 못하였습니다. '+ex.toString());
            });

	}

	handleTagIDChange(e) {
        this.addClass( document.getElementById('taginfo'),'red_taginfo_bg');
		//this.state.taginfo= e.target.value;
	}

	handleAgencyChange(e) {
		this.state.agency= e.target.value;
	}

	handleBookInfoChange(e) {
		this.state.bookinfo= e.target.value;
	}

	handlePhoneChange(e) {
		this.state.phone= e.target.value;
	}

	handlePrivacyChange(e) {
	    this.state.privacy= e.target.checked;
	}

	handleMessageChange(e) {
		this.state.message= e.target.value;
	}


	doOpenAlert(popup_message1) {
		this.setState({ ...this.state, popup_message: popup_message1, open: true });
		//this.state = { ...this.state, open: true };
	}

	doCloseAlert() {
		this.setState({ ...this.state, open: false });

		//this.state = { ...this.state, open: false };
	}

	submit_this() {
		//alert(JSON.stringify(this.state));
		//alert('id is ' + this.state.taginfo + ' Password is ' + this.state.sysinfo);
		this.dopost();
	}

    logPageView() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location + "&orgid=" + cookie.load("orgid"));
    }

    render() {
        this.logPageView();

        let contents;
        let orgID = cookie.load("orgid");

                        //onChange={this.handleTagIDChange.bind(this)} onFocus={this.doFocusTag}  />
		return (
			<React.Fragment>
				<Header headerTitle={this.state.headerTitle}/>
                <br/><p/>
                <br/><p/>
                <br/><p/>
				<div className="signLayout">

					<div className="form-group">
                    <br/>
                    <center>
                    <h2>
                    더책 - 불편사항 접수 
                    </h2>
                    </center>
                    <br/>

                    <table>

                    <tr>
                    <td width={90}>
                    <h4>
                        <a href="#" onClick={this.doFocusTag}>
                    NFC 태그 <NfcIcon style={{width:20,height:20,marginTop:5}} />
                        </a>
                        </h4>
                    </td>
                    <td>
						<input className="form-input form-input-lg" type="text" readonly id="taginfo"  placeholder="해당 도서를 태깅해 주세요."  value={this.state.taginfo}  
                        onChange={this.handleTagIDChange.bind(this)} onFocus={this.doFocusTag}  />
                    </td>
                    </tr>

                    <tr>
                    <td ><h4>휴대폰 정보</h4>
                    </td>
                    <td>
                        <input className="form-input form-input-lg" type="text" readonly id="sysinfo" placeholder="" 
                    value={this.state.sysinfo} />
                </td>
                </tr>

                <tr>
                <td ><h4>기관명</h4>
                </td>
                <td>
                    <input className="form-input form-input-lg" type="text" id="agency" 
                    placeholder="기관명" 
                    onChange={this.handleAgencyChange.bind(this)} />
                </td>
                </tr>

                <tr>
                <td ><h4>연락처</h4>
                </td>
                <td>
                    <input className="form-input form-input-lg" type="text" id="phone" 
                    placeholder="전화번호를 입력하세요" 
                    onChange={this.handlePhoneChange.bind(this)} />
                </td>
                </tr>

                <tr>
                <td ><h4>도서명</h4>
                </td>
                <td>
                    <input className="form-input form-input-lg" type="text" id="bookinfo" 
                    placeholder="도서 제목을 입력해주세요" 
                    onChange={this.handleBookInfoChange.bind(this)} />
                </td>
                </tr>

                <tr>
                <td colspan={2}>
                    <br/>
                    <textarea className="form-input form-input-lg" type="text" id="message"  rows={5}
                    onChange={this.handleMessageChange.bind(this)} 
                    placeholder="자세한 내용을 적어주시면 신속한 응대가 가능합니다."
                        >
                    </textarea>
                    
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                id="privacy"
                                name="privacy"
                                value="true"
                                onChange={this.handlePrivacyChange.bind(this)} 
                            />
                        }
                        label="개인 정보 수집 동의" id='privacy_label' />
                                    </td>
                                    </tr>

                                    <tr>
                                    <td colspan={2}>
                                        <Button variant="contained" fullWidth="true" className="btn-sign" onClick={this.submit_this.bind(this)}>
                                          보 내 기 
                                        </Button>
                                    </td>
                                    </tr>
                                    </table>
                                    </div>
                                </div>
                                <Dialog open={this.state.open} onClose={this.doCloseAlert}>
                                    <div className="dialog-body">
                                        <p>{this.state.popup_message} </p>
                                    </div>
                                    <div className="dialog-footer">
                                        <button onClick={this.doCloseAlert} color="primary" autoFocus className="btn btn-primary btn-sm">
                                            닫기
                                        </button>
                                        <br />
                                    </div>
                                </Dialog>
                            </React.Fragment>
		);
                }
}

export default TagComplaint;
